<template>
  <div class="docker">
    <Layout v-if="pageDate" :name="newspaper" :pageDate="pageDate" @emit-daily="getLayoutPageList"/>
    <Directory @getDirectoryList="getDirectoryList"/>
    <PeriodicalDate v-if="newspaperId" :newspaperId="newspaperId" @emit-per="getPageDate" />
  </div>
</template>

<script>
import Layout from '../components/Layout'
import Directory from '../components/Directory'
import PeriodicalDate from '../components/PeriodicalDate'
import { ref } from 'vue'
export default {
  name: 'School',
  components: { Layout, Directory, PeriodicalDate },
  props: {
    newspaperId: String,
    swiperIndex: Number
  },
  setup (props, { emit }) {
    const pageDate = ref()
    const getLayoutPageList = (data) => {
      emit('emit-home', data)
    }
    const getDirectoryList = (data) => {
      emit('getContentDirectory', data)
    }
    const getCurrentDate = (data) => {
      pageDate.value = data
    }
    const getPageDate = (data) => {
      pageDate.value = data
    }
    return {
      pageDate,
      getLayoutPageList,
      getCurrentDate,
      getDirectoryList,
      getPageDate
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../style/variables.scss';
.docker {
  display: flex;
  box-sizing: border-box;
  padding: 0 .18rem;
  width: 100%;
  line-height: 1.3rem;
  border-top:.1rem solid #f1f1f1;
}
</style>
